<template>
    <div class="flex-sub wrapper flex flex-direction padding">
        <div class="flex align-center justify-between">
            <div class="text-df">总结</div>
           <div class="flex">
               <el-button class="btn small" plain @click="$router.go(-1)">返回</el-button>
           </div>
        </div>
        <div class="flex-sub flex margin-top-sm bg-white padding-sm">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="publish-form radius" labelWidth="auto">
                <el-form-item ref="type" label="类型" prop="type" >
                    <el-select
                        v-model="ruleForm.type"
                        class="w-all"
                        placeholder="请选择">
                        <el-option
                            v-for="(item) in types"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item ref="meeting_time" label="时间" prop="meeting_time">
                    <el-date-picker
                        v-model="ruleForm.meeting_time"
                        placeholder="选择日期"
                        type="date"
                        value-format="yyyy-MM-dd" :disabled="readonly">
                    </el-date-picker>
                </el-form-item>
                <el-form-item ref="meeting_file"  label="上传材料"  prop="meeting_file">
                    <upload-file type="file" :files="ruleForm.files" multiple @uploadFile="uploadFile"></upload-file>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <ck-decoupled-editor class="bg-gray" ref="editor" :title="ruleForm.title" :content="ruleForm.content"></ck-decoupled-editor>
                </el-form-item>
            </el-form>
            <div class="flex flex-direction margin-left margin-top-xl">
<!--                <el-button :loading="loading" class="bg-white text-red" round @click="submitForm('ruleForm',1)"><i class="el-icon-edit"></i>保存</el-button>-->
<!--                <div></div>-->
                <el-button class=" btn mid" :loading="loading" type="primary" @click="submitForm('ruleForm',2)"><i class="el-icon-s-promotion"></i>发布</el-button>
                <div></div>
                <el-button class="margin-top-sm  btn mid" plain @click="templateDialog = true"><i class="el-icon-s-operation"></i>推荐模版</el-button>
            </div>

        </div>
        <template-dialog :dialog-visible="templateDialog" :type="0" @watchState="watchState"></template-dialog>
    </div>
</template>

<script>


import CkDecoupledEditor from "@/views/web/components/CKDecoupledEditor";
import {addReportMaterialConclusion, getReportMaterialDetail, getReportMaterialTypes} from "@/api";
import {TOAST, toast} from "@/utils/utils";
import TemplateDialog from "@/views/web/manager/page/standard/components/TemplateDialog";
import UploadFile from "@/views/web/components/UploadFile";
export default {
    name: "report_material-conclusion-add",
    components: {UploadFile, TemplateDialog, CkDecoupledEditor},
    data() {
        return {
            rid: 0,
            types:[],
            ruleForm: {
                type: '',
                meeting_time: '',
                title: '',
                content: '',
                files:[]
            },
            rules: {
                type: [
                    {required: true, message: '请选择类型', trigger: 'change'},
                ] ,
                meeting_time: [
                    {required: true, message: '请选择时间', trigger: 'change'},
                ],
            },
            loading: false,
            templateDialog: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit('setIndex', [6, 0])
        this.rid = Number( this.$route.params.id || 0)
        this.getReportMaterialTypes()
        if (this.rid) this.init()
    },
    methods: {
        async getReportMaterialTypes() {
            let _data = await getReportMaterialTypes()
            this.types = _data.data
        },
        async init() {
            let _data = await getReportMaterialDetail(this.rid,1)
            this.ruleForm.type = _data.data.type
            this.ruleForm.meeting_time = _data.data.activity_time
            this.ruleForm.title = _data.data.meeting_title
            this.ruleForm.content = _data.data.meeting_content
            this.ruleForm.files = _data.data.meeting_file
        },
        submitForm(formName,is_storage) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addItem(is_storage);
                }
            });
        },
        async addItem(is_storage) {
            let _info = this.$refs.editor.getInfo()
            if (!_info.content) return  toast('请输入内容', TOAST.error)
            this.loading = true
            let _data = await addReportMaterialConclusion(this.rid,_info.title || '无标题', _info.content,JSON.stringify(this.ruleForm.files),this.ruleForm.type,this.ruleForm.meeting_time,is_storage)
            this.loading = false
            if (_data.status === 200) {
                toast('保存成功', TOAST.success)
                this.$router.go(-1)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        uploadFile(data){
            if (data) {
                this.ruleForm.files = data.files
            }
        },
        watchState(data) {
            if (data) {
                this.ruleForm.title = data.title
                this.ruleForm.content = data.content
            }
            this.templateDialog = false;
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>
.wrapper {
    .choose-model {
        position: fixed;
        bottom: 200px;
        right: calc((100vw - 256px - 23.8cm) / 2 - 150px);
    }
}
</style>